import React from 'react';
import { Route, Routes } from 'react-router-dom';

import OrderListPage from './OrderListPage';
import { OrderPage } from './orderPage';

export default function CategoriesPage() {
  return (
      <Routes>
        <Route path='list/:type' element={<OrderListPage />} />
        <Route path='create' element={<OrderPage />} />
        <Route path=':id/:mode' element={<OrderPage />} />
      </Routes>
  );
}
